import { useDeviceType } from '@cian/ui-kit';
import classnames from 'classnames';
import * as React from 'react';

import * as style from './Header.css';

export const Header: React.FC = () => {
  const device = useDeviceType();

  const wrapperClassName = classnames(
    style['wrapper'],
    device === 'tablet' && style['wrapper-tablet'],
    device === 'phone' && style['wrapper-phone'],
  );

  return (
    <div className={wrapperClassName}>
      <div className={style['container']}>
        <div className={style['logo']} />
      </div>
    </div>
  );
};
